import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent, reactive, ref, computed, onMounted, onUnmounted } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import AgentsSelect from "@Broker/@Modules/agents/components/agents-select.vue";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import { getAgent } from "@Broker/@Modules/agents/api/agents-api";
import * as AgentGetters from "@Broker/@Modules/agents/store/agent-getters";
import { useAgentStoreGetters } from "@Broker/@Modules/agents/store/agent-helpers";
import { MORTGAGE_FREQUENCY, MORTGAGE_COMPOUNDING_PERIOD } from "@Shared/@Types/application/application-enums";
import { showToast } from "@Shared/@Utils/constants";
import i18n from "@Shared/i18n";
import { isEmpty, toNumber } from "lodash";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { CALCULATOR_FORMS } from "@Broker/@Types/financial-tools/types";
import { defaultPrintAction } from "../store/financial-tools-actions";
import { calcPay, getInterestCompoundingFrequency, getPaymentsPerYear, roundReg } from "@Broker/@Modules/financial-tools/utils";
const componentName = "AmortizationScheduleContainer";
const AMORT_SCENARIO = {
  NONE: "-1",
  DOUBLE_UP_TWICE_YEARLY: "1",
  DOUBLE_UP_EVERY_OTHER: "2",
  EXTRA_ON_ANNIVERSARY: "3",
  EXTRA_EVERY_PAYMENT: "4",
  INCREASE_ANNUALLY: "5"
};
const PAYMENT_STRUCTURE_EDIT_KIND = {
  NONE: "none",
  AMOUNT: "amount",
  AMOUNT_OR_PERCENT: "amount-or-percent"
};
const BASE_SCENARIO_FIELDS = ["totalLoanAmount", "amortization", "interestRate", "term", "payment", "frequency", "interestOnly", "compounded"];
const SCENARIO_DETAIL_FIELDS = ["balanceRemaining", "amortizationScenario", "extraPaymentAmount"];
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    AgentsSelect,
    MortgageCalculatorsToolbar,
    ReportTabLayout
  }),
  props: {
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const {
      CURRENT_APPLICATION,
      CURRENT_APPLICATION_ID,
      CLIENT_APPLICATION_OWNER_USERNAME,
      GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE
    } = useApplicationStoreGetters([ApplicationGetters.CURRENT_APPLICATION, ApplicationGetters.CURRENT_APPLICATION_ID, ApplicationGetters.CLIENT_APPLICATION_OWNER_USERNAME, ApplicationGetters.GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE]);
    const {
      CURRENT_USER_USERNAME
    } = useAccountStoreGetters([AccountGetters.CURRENT_USER_USERNAME]);
    const {
      GET_AGENT
    } = useAgentStoreGetters([AgentGetters.GET_AGENT]);
    const isEmbedded = computed(() => {
      var _props$initData;
      return Boolean((_props$initData = props.initData) == null ? void 0 : _props$initData.mortgageType);
    });
    const formData = reactive({
      totalLoanAmount: 0,
      interestRate: 0,
      interestOnly: false,
      term: 60,
      amortizPeriodMths: 300,
      frequency: MORTGAGE_FREQUENCY.MONTHLY,
      compounded: MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY,
      payment: 0,
      paymentOverride: false,
      closingDate: "",
      interestAdjustmentDate: "",
      firstPaymentDate: "",
      amortizationScenario: AMORT_SCENARIO.NONE,
      extraPaymentAmount: 0,
      preparedFor: "",
      agentUsername: ""
    });
    const scenarios = ref([]);
    const selectedAgent = ref(null);
    const selectedScenarioIndex = ref(0);
    const scheduleRows = ref([]);
    const pendingPaymentStructureOverrides = ref({});
    const hasPendingPaymentStructureChanges = ref(false);
    const isLoading = ref(false);
    const loadingSucceeded = ref(true);
    const amortizationScenarioOptions = [{
      label: i18n.t("financial-tools.doubleUpTwiceYearly"),
      value: AMORT_SCENARIO.DOUBLE_UP_TWICE_YEARLY
    }, {
      label: i18n.t("financial-tools.doubleUpEveryOtherPayment"),
      value: AMORT_SCENARIO.DOUBLE_UP_EVERY_OTHER
    }, {
      label: i18n.t("financial-tools.extraPaymentOnAnniversary"),
      value: AMORT_SCENARIO.EXTRA_ON_ANNIVERSARY
    }, {
      label: i18n.t("financial-tools.extraPaymentOnEveryPayment"),
      value: AMORT_SCENARIO.EXTRA_EVERY_PAYMENT
    }, {
      label: i18n.t("financial-tools.increasePaymentAmountAnnually"),
      value: AMORT_SCENARIO.INCREASE_ANNUALLY
    }];
    function scenarioRowHasExtras(scenario) {
      return !!scenario && scenario.amortizationScenario !== AMORT_SCENARIO.NONE && scenario.amortizationScenario !== "";
    }
    const activeScenario = computed(() => scenarios.value[selectedScenarioIndex.value] || null);
    const hasScenario = computed(() => scenarioRowHasExtras(activeScenario.value));
    function scenarioUsesTopExtraPaymentAmount(scenario) {
      var _context;
      return _includesInstanceProperty(_context = [AMORT_SCENARIO.EXTRA_ON_ANNIVERSARY, AMORT_SCENARIO.EXTRA_EVERY_PAYMENT, AMORT_SCENARIO.INCREASE_ANNUALLY]).call(_context, scenario);
    }
    const isTopExtraPaymentAmountEditable = computed(() => scenarioUsesTopExtraPaymentAmount(formData.amortizationScenario));
    const canCalculateWithNewPaymentStructure = computed(() => !!activeScenario.value && hasScenario.value && hasPendingPaymentStructureChanges.value);
    function getEmbeddedSubmissionDetails() {
      var _props$initData2;
      const mortgageType = (_props$initData2 = props.initData) == null ? void 0 : _props$initData2.mortgageType;
      if (!mortgageType) return null;
      const submissionDetail = GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE.value(mortgageType);
      return (submissionDetail == null ? void 0 : submissionDetail["submission-details"]) || null;
    }
    function getApplicationOwnerUsername() {
      const initData = props.initData;
      if (!initData.clientUsername || !CURRENT_APPLICATION_ID.value) {
        return CURRENT_USER_USERNAME.value || "";
      }
      const ownerUsername = CLIENT_APPLICATION_OWNER_USERNAME.value({
        applicationId: CURRENT_APPLICATION_ID.value,
        clientUsername: initData.clientUsername
      });
      return ownerUsername || CURRENT_USER_USERNAME.value || "";
    }
    function hasAutoCalculableBaseScenario() {
      const amount = toNumber(formData.totalLoanAmount);
      const rate = toNumber(formData.interestRate);
      const term = toNumber(formData.term);
      if (amount <= 0 || amount > 100000000) return false;
      if (rate <= 0 || rate > 100) return false;
      if (term <= 0) return false;
      if (formData.interestOnly) return true;
      const amort = toNumber(formData.amortizPeriodMths);
      return amort > 0 && amort <= 420 && amort >= term;
    }
    function getFrequencyLabel(freq) {
      const key = "application-form." + freq;
      const result = i18n.t(key);
      return typeof result === "string" ? result : freq;
    }
    function clonePaymentStructureOverrides(overrides) {
      const cloned = {};
      for (const [paymentNum, override] of _Object$entries(overrides || {})) {
        if (!override || !override.mode) continue;
        cloned[Number(paymentNum)] = {
          mode: override.mode,
          amount: roundReg(toNumber(override.amount)),
          percent: roundReg(toNumber(override.percent))
        };
      }
      return cloned;
    }
    function serializePaymentStructureOverrides(overrides) {
      var _context2, _context3, _context4;
      const normalized = _mapInstanceProperty(_context2 = _sortInstanceProperty(_context3 = _mapInstanceProperty(_context4 = _Object$keys(overrides || {})).call(_context4, Number)).call(_context3, (a, b) => a - b)).call(_context2, paymentNum => {
        const override = overrides == null ? void 0 : overrides[paymentNum];
        return {
          paymentNum,
          mode: (override == null ? void 0 : override.mode) || "amount",
          amount: roundReg(toNumber(override == null ? void 0 : override.amount)),
          percent: roundReg(toNumber(override == null ? void 0 : override.percent))
        };
      });
      return _JSON$stringify(normalized);
    }
    function createScenarioRow(params) {
      return {
        totalLoanAmount: params.totalLoanAmount,
        amortization: params.amortization,
        interestRate: params.interestRate,
        term: params.term,
        payment: params.payment,
        frequency: params.frequency,
        frequencyLabel: getFrequencyLabel(params.frequency),
        interestOnly: params.interestOnly,
        balanceRemaining: params.balanceRemaining,
        compounded: params.compounded,
        amortizationScenario: params.amortizationScenario,
        extraPaymentAmount: scenarioUsesTopExtraPaymentAmount(params.amortizationScenario) ? roundReg(toNumber(params.extraPaymentAmount)) : 0,
        paymentStructureOverrides: clonePaymentStructureOverrides(params.paymentStructureOverrides),
        derivedFromScenarioIndex: typeof params.derivedFromScenarioIndex === "number" ? params.derivedFromScenarioIndex : null
      };
    }
    function hydrateScenarioRow(scenario) {
      return createScenarioRow({
        totalLoanAmount: toNumber(scenario.totalLoanAmount),
        amortization: toNumber(scenario.amortization),
        interestRate: toNumber(scenario.interestRate),
        term: toNumber(scenario.term),
        payment: toNumber(scenario.payment),
        frequency: scenario.frequency || MORTGAGE_FREQUENCY.MONTHLY,
        interestOnly: !!scenario.interestOnly,
        balanceRemaining: toNumber(scenario.balanceRemaining),
        compounded: scenario.compounded || MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY,
        amortizationScenario: scenario.amortizationScenario || AMORT_SCENARIO.NONE,
        extraPaymentAmount: toNumber(scenario.extraPaymentAmount),
        paymentStructureOverrides: clonePaymentStructureOverrides(scenario.paymentStructureOverrides),
        derivedFromScenarioIndex: typeof scenario.derivedFromScenarioIndex === "number" ? scenario.derivedFromScenarioIndex : null
      });
    }
    function buildScenarioDefinition(scenario) {
      return {
        amortizationScenario: scenario.amortizationScenario,
        extraPaymentAmount: scenario.extraPaymentAmount,
        paymentStructureOverrides: clonePaymentStructureOverrides(scenario.paymentStructureOverrides)
      };
    }
    function buildScenarioRow(payment, balanceRemaining, paymentStructureOverrides = {}, derivedFromScenarioIndex = null) {
      return createScenarioRow({
        totalLoanAmount: toNumber(formData.totalLoanAmount),
        amortization: toNumber(formData.amortizPeriodMths),
        interestRate: toNumber(formData.interestRate),
        term: toNumber(formData.term),
        payment,
        frequency: formData.frequency,
        interestOnly: formData.interestOnly,
        balanceRemaining,
        compounded: formData.compounded,
        amortizationScenario: formData.amortizationScenario,
        extraPaymentAmount: toNumber(formData.extraPaymentAmount),
        paymentStructureOverrides,
        derivedFromScenarioIndex
      });
    }
    function updatePendingPaymentStructureChangeState() {
      var _activeScenario$value;
      hasPendingPaymentStructureChanges.value = serializePaymentStructureOverrides(pendingPaymentStructureOverrides.value) !== serializePaymentStructureOverrides((_activeScenario$value = activeScenario.value) == null ? void 0 : _activeScenario$value.paymentStructureOverrides);
    }
    function applyPendingPaymentStructureDraftToScheduleRows() {
      scheduleRows.value.forEach(row => {
        const pendingOverride = pendingPaymentStructureOverrides.value[row.paymentNum];
        if (row.scenarioRowEditKind === PAYMENT_STRUCTURE_EDIT_KIND.NONE) {
          row.scenarioRowAmountInput = 0;
          row.scenarioRowPercentInput = 0;
          return;
        }
        if (row.scenarioRowEditKind === PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT_OR_PERCENT) {
          row.scenarioRowAmountInput = (pendingOverride == null ? void 0 : pendingOverride.mode) === "amount" ? roundReg(toNumber(pendingOverride.amount)) : row.scenarioRowDefaultAmount;
          row.scenarioRowPercentInput = (pendingOverride == null ? void 0 : pendingOverride.mode) === "percent" ? roundReg(toNumber(pendingOverride.percent)) : row.scenarioRowDefaultPercent;
          return;
        }
        row.scenarioRowAmountInput = (pendingOverride == null ? void 0 : pendingOverride.mode) === "amount" ? roundReg(toNumber(pendingOverride.amount)) : row.scenarioRowDefaultAmount;
        row.scenarioRowPercentInput = row.scenarioRowDefaultPercent;
      });
      updatePendingPaymentStructureChangeState();
    }
    function resetPendingPaymentStructureDraft() {
      var _activeScenario$value2;
      pendingPaymentStructureOverrides.value = clonePaymentStructureOverrides((_activeScenario$value2 = activeScenario.value) == null ? void 0 : _activeScenario$value2.paymentStructureOverrides);
      hasPendingPaymentStructureChanges.value = false;
    }
    function isAnniversaryPayment(paymentNum, freqNum) {
      const frequencyPaymentsPerYear = Math.floor(freqNum);
      return paymentNum > frequencyPaymentsPerYear && (paymentNum - 1) % frequencyPaymentsPerYear === 0;
    }
    function getScenarioRowRule(definition, paymentNum, freqNum, currentPayment) {
      let targeted = false;
      let editKind = PAYMENT_STRUCTURE_EDIT_KIND.NONE;
      let defaultAmount = 0;
      let defaultPercent = 0;
      const scenario = definition.amortizationScenario;
      const frequencyPaymentsPerYear = Math.floor(freqNum);
      if (scenario === AMORT_SCENARIO.EXTRA_EVERY_PAYMENT) {
        targeted = true;
        editKind = PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT;
        defaultAmount = roundReg(definition.extraPaymentAmount);
      } else if (scenario === AMORT_SCENARIO.DOUBLE_UP_EVERY_OTHER) {
        targeted = paymentNum % 2 === 0;
        editKind = PAYMENT_STRUCTURE_EDIT_KIND.NONE;
        defaultAmount = targeted ? roundReg(currentPayment) : 0;
      } else if (scenario === AMORT_SCENARIO.DOUBLE_UP_TWICE_YEARLY) {
        const payInYear = (paymentNum - 1) % frequencyPaymentsPerYear + 1;
        const halfYear = Math.floor(frequencyPaymentsPerYear / 2);
        targeted = payInYear === halfYear || payInYear === frequencyPaymentsPerYear;
        editKind = PAYMENT_STRUCTURE_EDIT_KIND.NONE;
        defaultAmount = targeted ? roundReg(currentPayment) : 0;
      } else if (scenario === AMORT_SCENARIO.EXTRA_ON_ANNIVERSARY) {
        targeted = isAnniversaryPayment(paymentNum, freqNum);
        editKind = targeted ? PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT_OR_PERCENT : PAYMENT_STRUCTURE_EDIT_KIND.NONE;
        defaultAmount = targeted ? roundReg(definition.extraPaymentAmount) : 0;
      } else if (scenario === AMORT_SCENARIO.INCREASE_ANNUALLY) {
        targeted = isAnniversaryPayment(paymentNum, freqNum);
        editKind = targeted ? PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT_OR_PERCENT : PAYMENT_STRUCTURE_EDIT_KIND.NONE;
        defaultAmount = targeted ? roundReg(definition.extraPaymentAmount) : 0;
      }
      return {
        targeted,
        editKind,
        defaultAmount,
        defaultPercent
      };
    }
    function getResolvedScenarioRow(definition, paymentNum, freqNum, currentPayment, currentBalance) {
      const rule = getScenarioRowRule(definition, paymentNum, freqNum, currentPayment);
      const override = rule.targeted ? definition.paymentStructureOverrides[paymentNum] : undefined;
      const mode = override == null ? void 0 : override.mode;
      const effectiveMode = mode != null ? mode : "amount";
      let amountValue = rule.defaultAmount;
      let percentValue = rule.defaultPercent;
      if (override && mode === "amount") {
        amountValue = roundReg(toNumber(override.amount));
      }
      if (override && rule.editKind === PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT_OR_PERCENT && mode === "percent") {
        percentValue = roundReg(toNumber(override.percent));
      }
      let paymentForThisPeriod = currentPayment;
      let extraPayment = 0;
      if (rule.targeted && rule.editKind === PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT_OR_PERCENT) {
        if (definition.amortizationScenario === AMORT_SCENARIO.INCREASE_ANNUALLY) {
          if (effectiveMode === "percent" && percentValue > 0) {
            paymentForThisPeriod = roundReg(currentPayment + currentBalance * (percentValue / 100));
          } else if (effectiveMode === "amount" && amountValue > 0) {
            paymentForThisPeriod = roundReg(currentPayment + amountValue);
          }
        } else {
          if (effectiveMode === "percent" && percentValue > 0) {
            extraPayment = roundReg(currentBalance * (percentValue / 100));
          } else if (effectiveMode === "amount" && amountValue > 0) {
            extraPayment = amountValue;
          }
        }
      } else if (rule.targeted) {
        extraPayment = amountValue;
      }
      return {
        targeted: rule.targeted,
        editKind: rule.editKind,
        defaultAmount: rule.defaultAmount,
        defaultPercent: rule.defaultPercent,
        amountValue,
        percentValue,
        paymentForThisPeriod,
        extraPayment
      };
    }
    function compareScenarioFields(currentScenario, nextScenario, fields) {
      return fields.every(field => currentScenario[field] === nextScenario[field]);
    }
    function hasSameScenarioBase(currentScenario, nextScenario) {
      return compareScenarioFields(currentScenario, nextScenario, BASE_SCENARIO_FIELDS);
    }
    function isPlaceholderScenario(scenario) {
      return scenario.amortizationScenario === AMORT_SCENARIO.NONE && scenario.extraPaymentAmount === 0 && serializePaymentStructureOverrides(scenario.paymentStructureOverrides) === serializePaymentStructureOverrides();
    }
    function isSameScenario(currentScenario, nextScenario) {
      return hasSameScenarioBase(currentScenario, nextScenario) && compareScenarioFields(currentScenario, nextScenario, SCENARIO_DETAIL_FIELDS) && serializePaymentStructureOverrides(currentScenario.paymentStructureOverrides) === serializePaymentStructureOverrides(nextScenario.paymentStructureOverrides);
    }
    function validateInputs() {
      const amount = toNumber(formData.totalLoanAmount);
      if (amount <= 0 || amount > 100000000) {
        showToast("error", i18n.t("financial-tools.mortgage_amount") + ": " + i18n.t("financial-tools.message_missing_question_1"));
        return false;
      }
      const rate = toNumber(formData.interestRate);
      if (rate <= 0 || rate > 100) {
        showToast("error", i18n.t("financial-tools.interest_rate") + ": " + i18n.t("financial-tools.message_missing_question_2"));
        return false;
      }
      const term = toNumber(formData.term);
      if (term <= 0) {
        showToast("error", i18n.t("financial-tools.unableToCompleteCalculation") + ": Term");
        return false;
      }
      if (!formData.interestOnly) {
        const amort = toNumber(formData.amortizPeriodMths);
        if (amort <= 0 || amort > 420) {
          showToast("error", i18n.t("financial-tools.amortization_period") + ": " + i18n.t("financial-tools.message_missing_question_3"));
          return false;
        }
        if (amort < term) {
          showToast("error", i18n.t("financial-tools.alertGenericAmScenarioTermMoreThanAmortiz").toString());
          return false;
        }
      }
      return true;
    }
    function runAmortLoop(mortgage, payment, intFact, numPayments, definition, freqNum) {
      let principalBal = mortgage;
      let totalInterest = 0;
      let totalPrincipal = 0;
      const rows = [];
      let scenarioPayment = payment;
      let finalScenarioPayment = payment;
      for (let payNum = 1; payNum <= numPayments && principalBal > 0; payNum++) {
        const resolvedRow = getResolvedScenarioRow(definition, payNum, freqNum, scenarioPayment, principalBal);
        const paymentForThisPeriod = resolvedRow.paymentForThisPeriod;
        const extraPayment = resolvedRow.extraPayment;
        finalScenarioPayment = paymentForThisPeriod;
        const interestPayment = roundReg(principalBal * intFact);
        const principalPayment = roundReg(paymentForThisPeriod - interestPayment);
        const totalPaymentThisPeriod = principalPayment + extraPayment;
        const actualPrincipal = Math.min(roundReg(totalPaymentThisPeriod), principalBal);
        if (actualPrincipal <= 0) break;
        principalBal = roundReg(principalBal - actualPrincipal);
        if (principalBal < (interestPayment + totalPaymentThisPeriod) / 2 && principalBal > 0) {
          const extra = principalBal;
          principalBal = 0;
          totalInterest += interestPayment;
          totalPrincipal += actualPrincipal + extra;
          rows.push({
            paymentNum: payNum,
            extraPayment,
            scenarioInterest: interestPayment,
            scenarioPrincipal: roundReg(actualPrincipal + extra),
            scenarioBalance: 0,
            originalInterest: 0,
            originalPrincipal: 0,
            originalBalance: 0,
            scenarioRowTargeted: resolvedRow.targeted,
            scenarioRowEditKind: resolvedRow.editKind,
            scenarioRowDefaultAmount: resolvedRow.defaultAmount,
            scenarioRowDefaultPercent: resolvedRow.defaultPercent,
            scenarioRowAmountInput: resolvedRow.amountValue,
            scenarioRowPercentInput: resolvedRow.percentValue
          });
        } else {
          totalInterest += interestPayment;
          totalPrincipal += actualPrincipal;
          rows.push({
            paymentNum: payNum,
            extraPayment,
            scenarioInterest: interestPayment,
            scenarioPrincipal: actualPrincipal,
            scenarioBalance: principalBal,
            originalInterest: 0,
            originalPrincipal: 0,
            originalBalance: 0,
            scenarioRowTargeted: resolvedRow.targeted,
            scenarioRowEditKind: resolvedRow.editKind,
            scenarioRowDefaultAmount: resolvedRow.defaultAmount,
            scenarioRowDefaultPercent: resolvedRow.defaultPercent,
            scenarioRowAmountInput: resolvedRow.amountValue,
            scenarioRowPercentInput: resolvedRow.percentValue
          });
        }
        scenarioPayment = paymentForThisPeriod;
      }
      return {
        rows,
        totalInterest: roundReg(totalInterest),
        totalPrincipal: roundReg(totalPrincipal),
        finalBalance: roundReg(principalBal),
        finalScenarioPayment: roundReg(finalScenarioPayment)
      };
    }
    function runOriginalLoop(mortgage, payment, intFact, numPayments, interestOnly) {
      let principalBal = mortgage;
      let totalInterest = 0;
      let totalPrincipal = 0;
      const rows = [];
      for (let payNum = 1; payNum <= numPayments && principalBal > 0; payNum++) {
        const interestPayment = roundReg(principalBal * intFact);
        if (interestOnly) {
          totalInterest += interestPayment;
          rows.push({
            interest: interestPayment,
            principal: 0,
            balance: principalBal
          });
          continue;
        }
        const principalPayment = roundReg(payment - interestPayment);
        const checkBal = Math.min(principalPayment, principalBal);
        if (checkBal <= 0) break;
        principalBal = roundReg(principalBal - checkBal);
        if (principalBal > 0 && principalBal < (interestPayment + principalPayment) / 2) {
          totalInterest += interestPayment;
          totalPrincipal += checkBal + principalBal;
          rows.push({
            interest: interestPayment,
            principal: roundReg(checkBal + principalBal),
            balance: 0
          });
          principalBal = 0;
        } else {
          totalInterest += interestPayment;
          totalPrincipal += checkBal;
          rows.push({
            interest: interestPayment,
            principal: checkBal,
            balance: principalBal
          });
        }
      }
      return {
        rows,
        totalInterest: roundReg(totalInterest),
        totalPrincipal: roundReg(totalPrincipal),
        finalBalance: roundReg(principalBal)
      };
    }
    function runFullAmortLoop(mortgage, payment, intFact, definition, freqNum, payNumStart = 0) {
      let principalBal = mortgage;
      let totalInterest = 0;
      let payNum = payNumStart;
      let scenarioPayment = payment;
      const maxPayments = freqNum * 100;
      while (principalBal > 0 && payNum < maxPayments) {
        payNum++;
        const resolvedRow = getResolvedScenarioRow(definition, payNum, freqNum, scenarioPayment, principalBal);
        const paymentForThisPeriod = resolvedRow.paymentForThisPeriod;
        const extraPayment = resolvedRow.extraPayment;
        const interestPayment = roundReg(principalBal * intFact);
        const principalPayment = roundReg(paymentForThisPeriod - interestPayment);
        const totalPrincipalPayment = principalPayment + extraPayment;
        const actualPrincipal = Math.min(roundReg(totalPrincipalPayment), principalBal);
        if (actualPrincipal <= 0) break;
        totalInterest += interestPayment;
        principalBal = roundReg(principalBal - actualPrincipal);
        scenarioPayment = paymentForThisPeriod;
      }
      return {
        totalPayments: payNum - payNumStart,
        totalInterest: roundReg(totalInterest)
      };
    }
    function buildPendingPaymentStructureOverride(row) {
      const amount = roundReg(toNumber(row.scenarioRowAmountInput));
      const percent = roundReg(toNumber(row.scenarioRowPercentInput));
      if (row.scenarioRowEditKind === PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT_OR_PERCENT) {
        if (percent > 0) {
          return percent === row.scenarioRowDefaultPercent ? null : {
            mode: "percent",
            amount: 0,
            percent
          };
        }
        if (amount > 0) {
          return amount === row.scenarioRowDefaultAmount ? null : {
            mode: "amount",
            amount,
            percent: 0
          };
        }
        return null;
      }
      if (row.scenarioRowEditKind === PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT) {
        return amount === row.scenarioRowDefaultAmount ? null : {
          mode: "amount",
          amount,
          percent: 0
        };
      }
      return null;
    }
    function syncPendingPaymentStructureOverride(row) {
      const nextOverride = buildPendingPaymentStructureOverride(row);
      if (nextOverride) {
        pendingPaymentStructureOverrides.value[row.paymentNum] = nextOverride;
      } else {
        delete pendingPaymentStructureOverrides.value[row.paymentNum];
      }
      updatePendingPaymentStructureChangeState();
    }
    function handleScenarioRowAmountChange(paymentNum, value) {
      var _context5;
      const row = _findInstanceProperty(_context5 = scheduleRows.value).call(_context5, item => item.paymentNum === paymentNum);
      if (!row) return;
      row.scenarioRowAmountInput = roundReg(toNumber(value));
      if (row.scenarioRowEditKind === PAYMENT_STRUCTURE_EDIT_KIND.AMOUNT_OR_PERCENT && row.scenarioRowAmountInput > 0) {
        row.scenarioRowPercentInput = 0;
      }
      syncPendingPaymentStructureOverride(row);
    }
    function handleScenarioRowPercentChange(paymentNum, value) {
      var _context6;
      const row = _findInstanceProperty(_context6 = scheduleRows.value).call(_context6, item => item.paymentNum === paymentNum);
      if (!row) return;
      row.scenarioRowPercentInput = roundReg(toNumber(value));
      if (row.scenarioRowPercentInput > 0) {
        row.scenarioRowAmountInput = row.scenarioRowDefaultAmount;
      }
      syncPendingPaymentStructureOverride(row);
    }
    const scenarioTotals = computed(() => {
      let interest = 0;
      let principal = 0;
      let balance = 0;
      for (const row of scheduleRows.value) {
        interest += row.scenarioInterest;
        principal += row.scenarioPrincipal;
      }
      balance = scheduleRows.value.length > 0 ? scheduleRows.value[scheduleRows.value.length - 1].scenarioBalance : 0;
      return {
        interest,
        principal,
        balance
      };
    });
    const originalTotals = computed(() => {
      let interest = 0;
      let principal = 0;
      let balance = 0;
      for (const row of scheduleRows.value) {
        interest += row.originalInterest;
        principal += row.originalPrincipal;
      }
      balance = scheduleRows.value.length > 0 ? scheduleRows.value[scheduleRows.value.length - 1].originalBalance : 0;
      return {
        interest,
        principal,
        balance
      };
    });
    const interestAdjustmentAmount = computed(() => {
      if (isEmpty(formData.closingDate) || isEmpty(formData.interestAdjustmentDate)) return 0;
      const closing = new Date(formData.closingDate);
      const adjDate = new Date(formData.interestAdjustmentDate);
      if (isNaN(closing.getTime()) || isNaN(adjDate.getTime())) return 0;
      const diffDays = Math.max(0, (adjDate.getTime() - closing.getTime()) / (1000 * 60 * 60 * 24));
      const totalLoanAmount = toNumber(formData.totalLoanAmount);
      const rate = toNumber(formData.interestRate) / 100;
      const compoundingPeriodsPerYear = getInterestCompoundingFrequency(formData.compounded);
      const growthFactor = Math.pow(1 + rate / compoundingPeriodsPerYear, compoundingPeriodsPerYear * diffDays / 365);
      return roundReg(totalLoanAmount * (growthFactor - 1));
    });
    const footerData = ref({
      effectiveAmortization: "",
      interestSavedOverTerm: 0,
      interestSavedOverAmortization: 0
    });
    function handleInterestOnlyChange(checked) {
      if (checked) {
        formData.amortizPeriodMths = 0;
      } else if (formData.amortizPeriodMths === 0) {
        formData.amortizPeriodMths = 300;
      }
    }
    function handlePaymentOverrideChange(checked) {
      if (!checked) {
        formData.payment = 0;
      }
    }
    function getAgentFromStore(agentUsername) {
      return agentUsername ? GET_AGENT.value(agentUsername) || null : null;
    }
    function getAgentSelectionOption(agent) {
      if (!agent) return null;
      if (typeof agent === "string") return {
        id: agent,
        username: agent
      };
      if (Array.isArray(agent)) return agent[agent.length - 1] || null;
      return agent;
    }
    async function loadAgentContactDetails(agentUsername) {
      if (!agentUsername) return {
        email: "",
        phoneNumber: ""
      };
      try {
        const agent = await getAgent(agentUsername);
        const contactDetails = {
          email: (agent == null ? void 0 : agent.email) || "",
          phoneNumber: (agent == null ? void 0 : agent.phoneNumber) || ""
        };
        return contactDetails;
      } catch (e) {
        console.error(e);
        return {
          email: "",
          phoneNumber: ""
        };
      }
    }
    function handleAgentChange(agent, type) {
      if (type && type !== "select") return;
      const agentOption = getAgentSelectionOption(agent);
      const agentUsername = (agentOption == null ? void 0 : agentOption.username) || (agentOption == null ? void 0 : agentOption.id) || "";
      formData.agentUsername = agentUsername;
      selectedAgent.value = getAgentFromStore(agentUsername) || agentOption;
    }
    function getSelectedAgentDetails(agentUsername, agentContactDetails) {
      var _selectedAgent$value, _selectedAgent$value2, _context7;
      const storeAgent = getAgentFromStore(agentUsername);
      const cachedSelectedAgent = ((_selectedAgent$value = selectedAgent.value) == null ? void 0 : _selectedAgent$value.username) === agentUsername || ((_selectedAgent$value2 = selectedAgent.value) == null ? void 0 : _selectedAgent$value2.id) === agentUsername ? selectedAgent.value : null;
      const agentSource = storeAgent || cachedSelectedAgent;
      const givenName = (agentSource == null ? void 0 : agentSource.givenName) || "";
      const familyName = (agentSource == null ? void 0 : agentSource.familyName) || "";
      return {
        fullName: _trimInstanceProperty(_context7 = `${givenName} ${familyName}`).call(_context7),
        email: agentContactDetails.email,
        phoneNumber: agentContactDetails.phoneNumber
      };
    }
    function populateFromApplication() {
      var _currentApplication$m, _currentApplication$m2;
      const initData = props.initData;
      if (!initData.mortgageType) return false;
      const submissionDetails = getEmbeddedSubmissionDetails();
      const currentApplication = CURRENT_APPLICATION.value;
      formData.totalLoanAmount = toNumber(initData.totalLoanAmount || 0);
      formData.interestRate = toNumber(initData.interestRate || 0);
      formData.interestOnly = initData.interestOnly === true;
      formData.term = toNumber(initData.mortgageTerm || 0);
      formData.amortizPeriodMths = formData.interestOnly ? 0 : toNumber(initData.amortizPeriodMths || 0);
      formData.frequency = initData.frequency || MORTGAGE_FREQUENCY.MONTHLY;
      formData.compounded = initData.compoundedPeriod || MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY;
      formData.payment = 0;
      formData.paymentOverride = false;
      formData.closingDate = ((_currentApplication$m = currentApplication["mortgage-details"]) == null ? void 0 : (_currentApplication$m2 = _currentApplication$m["mortgage-details"]) == null ? void 0 : _currentApplication$m2["closing-date"]) || "";
      formData.interestAdjustmentDate = (submissionDetails == null ? void 0 : submissionDetails["interest-adjustment-date"]) || "";
      formData.firstPaymentDate = (submissionDetails == null ? void 0 : submissionDetails["first-payment-date"]) || "";
      formData.amortizationScenario = AMORT_SCENARIO.NONE;
      formData.extraPaymentAmount = 0;
      formData.preparedFor = initData.prepared_for || "";
      formData.agentUsername = getApplicationOwnerUsername();
      selectedScenarioIndex.value = 0;
      scenarios.value = [];
      scheduleRows.value = [];
      resetPendingPaymentStructureDraft();
      return true;
    }
    function generateSchedule() {
      if (scenarios.value.length === 0) {
        scheduleRows.value = [];
        resetPendingPaymentStructureDraft();
        return;
      }
      const sc = scenarios.value[selectedScenarioIndex.value];
      if (!sc) return;
      const selectedScenarioHasExtras = scenarioRowHasExtras(sc);
      const intrate = sc.interestRate / 100;
      const compoundin = getInterestCompoundingFrequency(sc.compounded);
      const freqNum = getPaymentsPerYear(sc.frequency);
      const intFact = Math.pow(1 + intrate / compoundin, compoundin / freqNum) - 1;
      const numPayments = Math.ceil(sc.term * freqNum / 12);
      const origResult = runOriginalLoop(sc.totalLoanAmount, sc.payment, intFact, numPayments, sc.interestOnly);
      const scenarioDefinition = buildScenarioDefinition(sc);
      const scenResult = runAmortLoop(sc.totalLoanAmount, sc.payment, intFact, numPayments, scenarioDefinition, freqNum);
      const maxRows = Math.max(origResult.rows.length, scenResult.rows.length);
      const merged = [];
      for (let i = 0; i < maxRows; i++) {
        const orig = origResult.rows[i];
        const scen = scenResult.rows[i];
        merged.push({
          paymentNum: i + 1,
          extraPayment: scen ? scen.extraPayment : 0,
          scenarioInterest: scen ? scen.scenarioInterest : 0,
          scenarioPrincipal: scen ? scen.scenarioPrincipal : 0,
          scenarioBalance: scen ? scen.scenarioBalance : 0,
          originalInterest: orig ? orig.interest : 0,
          originalPrincipal: orig ? orig.principal : 0,
          originalBalance: orig ? orig.balance : 0,
          scenarioRowTargeted: scen ? scen.scenarioRowTargeted : false,
          scenarioRowEditKind: scen ? scen.scenarioRowEditKind : PAYMENT_STRUCTURE_EDIT_KIND.NONE,
          scenarioRowDefaultAmount: scen ? scen.scenarioRowDefaultAmount : 0,
          scenarioRowDefaultPercent: scen ? scen.scenarioRowDefaultPercent : 0,
          scenarioRowAmountInput: scen ? scen.scenarioRowAmountInput : 0,
          scenarioRowPercentInput: scen ? scen.scenarioRowPercentInput : 0
        });
      }
      scheduleRows.value = merged;
      const amortMonths = sc.interestOnly ? 0 : sc.amortization;
      const termMonths = sc.term;
      const remainingMonths = Math.max(0, amortMonths - termMonths);
      let effectiveMonths = remainingMonths;
      let effectiveStr = "";
      let interestSavedAmort = 0;
      const scenarioRemainingBal = scenResult.rows.length > 0 ? scenResult.rows[scenResult.rows.length - 1].scenarioBalance : sc.totalLoanAmount;
      const simpleDefinition = {
        amortizationScenario: AMORT_SCENARIO.NONE,
        extraPaymentAmount: 0,
        paymentStructureOverrides: {}
      };
      if (selectedScenarioHasExtras && !sc.interestOnly) {
        var _context8;
        const postTermDefinition = _includesInstanceProperty(_context8 = [AMORT_SCENARIO.DOUBLE_UP_TWICE_YEARLY, AMORT_SCENARIO.DOUBLE_UP_EVERY_OTHER]).call(_context8, sc.amortizationScenario) ? scenarioDefinition : simpleDefinition;
        const scenarioPostTermPayment = sc.amortizationScenario === AMORT_SCENARIO.INCREASE_ANNUALLY ? scenResult.finalScenarioPayment : sc.payment;
        const scenPostTerm = runFullAmortLoop(scenarioRemainingBal, scenarioPostTermPayment, intFact, postTermDefinition, freqNum, sc.term);
        const remainingMonthsFromCalculation = Math.ceil(scenPostTerm.totalPayments / (freqNum / 12));
        effectiveMonths = Math.min(remainingMonthsFromCalculation, remainingMonths);
        const origPostTerm = runFullAmortLoop(origResult.finalBalance, sc.payment, intFact, {
          amortizationScenario: AMORT_SCENARIO.NONE,
          extraPaymentAmount: 0,
          paymentStructureOverrides: {}
        }, freqNum, sc.term);
        const scenTotalAmortInterest = scenResult.totalInterest + scenPostTerm.totalInterest;
        const origTotalAmortInterest = origResult.totalInterest + origPostTerm.totalInterest;
        interestSavedAmort = Math.max(0, origTotalAmortInterest - scenTotalAmortInterest);
        footerData.value.interestSavedOverTerm = origResult.totalInterest - scenResult.totalInterest;
      } else {
        const scenPostTerm = runFullAmortLoop(scenarioRemainingBal, sc.payment, intFact, simpleDefinition, freqNum, sc.term);
        const remainingMonthsFromCalculation = Math.ceil(scenPostTerm.totalPayments / (freqNum / 12));
        effectiveMonths = Math.min(remainingMonthsFromCalculation, remainingMonths);
        footerData.value.interestSavedOverTerm = 0;
      }
      const effYears = Math.floor(effectiveMonths / 12);
      const effMonths = effectiveMonths % 12;
      effectiveStr = effYears + " " + i18n.t("financial-tools.years");
      if (effMonths > 0) effectiveStr += " " + effMonths + " " + i18n.t("financial-tools.monthss");
      footerData.value.effectiveAmortization = effectiveStr;
      footerData.value.interestSavedOverAmortization = interestSavedAmort;
      resetPendingPaymentStructureDraft();
    }
    function calculate() {
      if (!validateInputs()) return;
      const totalLoanAmount = toNumber(formData.totalLoanAmount);
      const intrate = toNumber(formData.interestRate) / 100;
      const compoundin = getInterestCompoundingFrequency(formData.compounded);
      const freqNum = getPaymentsPerYear(formData.frequency);
      const term = toNumber(formData.term);
      const amort = toNumber(formData.amortizPeriodMths);
      const intFact = Math.pow(1 + intrate / compoundin, compoundin / freqNum) - 1;
      let payment;
      if (formData.interestOnly) {
        payment = roundReg(totalLoanAmount * intFact);
      } else if (formData.paymentOverride && toNumber(formData.payment) > 0) {
        payment = toNumber(formData.payment);
      } else {
        payment = calcPay(totalLoanAmount, amort, intrate, compoundin, freqNum, formData.frequency);
      }
      formData.payment = roundReg(payment);
      const nextScenario = buildScenarioRow(payment, totalLoanAmount);
      const nextScenarioResult = runAmortLoop(totalLoanAmount, payment, intFact, term, buildScenarioDefinition(nextScenario), freqNum);
      nextScenario.balanceRemaining = nextScenarioResult.finalBalance;
      const selectedScenario = scenarios.value[selectedScenarioIndex.value];
      const shouldReplaceSelectedScenario = !!selectedScenario && hasSameScenarioBase(selectedScenario, nextScenario) && (isPlaceholderScenario(selectedScenario) || isSameScenario(selectedScenario, nextScenario));
      if (shouldReplaceSelectedScenario) {
        var _context9;
        _spliceInstanceProperty(_context9 = scenarios.value).call(_context9, selectedScenarioIndex.value, 1, nextScenario);
        generateSchedule();
        return;
      }
      if (scenarios.value.length >= 10) {
        showToast("error", "Maximum of 10 scenarios reached.");
        return;
      }
      scenarios.value.push(nextScenario);
      selectedScenarioIndex.value = scenarios.value.length - 1;
      generateSchedule();
    }
    function calculateWithNewPaymentStructure() {
      const sc = activeScenario.value;
      if (!sc || !canCalculateWithNewPaymentStructure.value) return;
      if (scenarios.value.length >= 10) {
        showToast("error", "Maximum of 10 scenarios reached.");
        return;
      }
      const compoundin = getInterestCompoundingFrequency(sc.compounded);
      const freqNum = getPaymentsPerYear(sc.frequency);
      const intFact = Math.pow(1 + sc.interestRate / 100 / compoundin, compoundin / freqNum) - 1;
      const nextOverrides = clonePaymentStructureOverrides(pendingPaymentStructureOverrides.value);
      const nextDefinition = {
        amortizationScenario: sc.amortizationScenario,
        extraPaymentAmount: sc.extraPaymentAmount,
        paymentStructureOverrides: nextOverrides
      };
      const nextScenarioResult = runAmortLoop(sc.totalLoanAmount, sc.payment, intFact, sc.term, nextDefinition, freqNum);
      scenarios.value.push(createScenarioRow({
        totalLoanAmount: sc.totalLoanAmount,
        amortization: sc.amortization,
        interestRate: sc.interestRate,
        term: sc.term,
        payment: sc.payment,
        frequency: sc.frequency,
        interestOnly: sc.interestOnly,
        balanceRemaining: nextScenarioResult.finalBalance,
        compounded: sc.compounded,
        amortizationScenario: sc.amortizationScenario,
        extraPaymentAmount: sc.extraPaymentAmount,
        paymentStructureOverrides: nextOverrides,
        derivedFromScenarioIndex: selectedScenarioIndex.value
      }));
      selectedScenarioIndex.value = scenarios.value.length - 1;
      generateSchedule();
    }
    function onScenarioSelect(idx) {
      selectedScenarioIndex.value = idx;
      generateSchedule();
    }
    function clearSelectedScenario() {
      var _context0;
      if (scenarios.value.length === 0) return;
      _spliceInstanceProperty(_context0 = scenarios.value).call(_context0, selectedScenarioIndex.value, 1);
      if (scenarios.value.length === 0) {
        selectedScenarioIndex.value = 0;
        scheduleRows.value = [];
        resetPendingPaymentStructureDraft();
      } else {
        selectedScenarioIndex.value = Math.min(selectedScenarioIndex.value, scenarios.value.length - 1);
        generateSchedule();
      }
    }
    function clearAllScenarios() {
      scenarios.value = [];
      selectedScenarioIndex.value = 0;
      scheduleRows.value = [];
      resetPendingPaymentStructureDraft();
    }
    function clearAllExtraPayments() {
      formData.amortizationScenario = AMORT_SCENARIO.NONE;
      formData.extraPaymentAmount = 0;
      if (scenarios.value.length > 0) {
        generateSchedule();
      }
    }
    function clearForm() {
      formData.totalLoanAmount = 0;
      formData.interestRate = 0;
      formData.interestOnly = false;
      formData.term = 60;
      formData.amortizPeriodMths = 300;
      formData.frequency = MORTGAGE_FREQUENCY.MONTHLY;
      formData.compounded = MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY;
      formData.payment = 0;
      formData.paymentOverride = false;
      formData.closingDate = "";
      formData.interestAdjustmentDate = "";
      formData.firstPaymentDate = "";
      formData.amortizationScenario = AMORT_SCENARIO.NONE;
      formData.extraPaymentAmount = 0;
      formData.preparedFor = "";
      formData.agentUsername = "";
      selectedAgent.value = null;
      scenarios.value = [];
      selectedScenarioIndex.value = 0;
      scheduleRows.value = [];
      resetPendingPaymentStructureDraft();
    }
    const runReport = async () => {
      if (hasPendingPaymentStructureChanges.value) {
        showToast("error", i18n.t("financial-tools.calculateWithNewPaymentStructureBeforePrinting").toString());
        return;
      }
      if (scenarios.value.length === 0) {
        calculate();
        if (scenarios.value.length === 0) return;
      }
      isLoading.value = true;
      loadingSucceeded.value = true;
      const sc = scenarios.value[selectedScenarioIndex.value];
      const printAgentUsername = formData.agentUsername || CURRENT_USER_USERNAME.value;
      const printAgentContactDetails = await loadAgentContactDetails(printAgentUsername);
      const printAgentDetails = getSelectedAgentDetails(printAgentUsername, printAgentContactDetails);
      const data = {
        paymentFrequency: sc.frequency,
        mortgageAmount: sc.totalLoanAmount,
        interestRate: sc.interestRate,
        amortizationPeriod: sc.amortization,
        term: sc.term,
        PandI: sc.payment,
        interestOnly: sc.interestOnly,
        compounded: sc.compounded,
        preparedFor: formData.preparedFor,
        agentDetails: printAgentDetails,
        amortizationScenario: sc.amortizationScenario,
        extraPaymentAmount: sc.extraPaymentAmount,
        selectedScenarioIndex: selectedScenarioIndex.value,
        selectedScenario: sc,
        scheduleData: scheduleRows.value,
        footerData: {
          effectiveAmortization: footerData.value.effectiveAmortization,
          interestSavedOverTerm: footerData.value.interestSavedOverTerm,
          interestSavedOverAmortization: footerData.value.interestSavedOverAmortization
        },
        scenarios: scenarios.value
      };
      try {
        await defaultPrintAction({
          type: CALCULATOR_FORMS.AMORTIZATION_SCHEDULE,
          data
        });
      } catch (e) {
        loadingSucceeded.value = false;
        console.error(e);
      }
      isLoading.value = false;
    };
    let populatedFromApplication = false;
    if (isEmbedded.value) {
      clearForm();
      populatedFromApplication = populateFromApplication();
    }
    onMounted(() => {
      if (isEmbedded.value) {
        if (populatedFromApplication && hasAutoCalculableBaseScenario()) {
          calculate();
        }
        return;
      }
      const saved = localStorage.getItem(componentName);
      if (saved) {
        try {
          var _context1;
          const parsed = JSON.parse(saved);
          _Object$assign(formData, parsed.formData || {});
          scenarios.value = Array.isArray(parsed.scenarios) ? _mapInstanceProperty(_context1 = parsed.scenarios).call(_context1, scenario => hydrateScenarioRow(scenario)) : [];
          selectedScenarioIndex.value = scenarios.value.length ? Math.min(Math.max(0, toNumber(parsed.selectedScenarioIndex)), scenarios.value.length - 1) : 0;
          if (scenarios.value.length > 0) {
            generateSchedule();
            if (parsed.pendingPaymentStructureOverrides) {
              pendingPaymentStructureOverrides.value = clonePaymentStructureOverrides(parsed.pendingPaymentStructureOverrides);
              applyPendingPaymentStructureDraftToScheduleRows();
            }
          }
        } catch (e) {
          console.error("Error parsing localStorage for " + componentName, e);
          localStorage.removeItem(componentName);
        }
      }
    });
    onUnmounted(() => {
      if (isEmbedded.value) return;
      localStorage.setItem(componentName, _JSON$stringify({
        formData,
        scenarios: scenarios.value,
        selectedScenarioIndex: selectedScenarioIndex.value,
        pendingPaymentStructureOverrides: pendingPaymentStructureOverrides.value
      }));
    });
    const applicationFieldOptions = APPLICATION_FIELD_OPTIONS();
    return {
      formData,
      isEmbedded,
      scenarios,
      selectedScenarioIndex,
      scheduleRows,
      pendingPaymentStructureOverrides,
      hasPendingPaymentStructureChanges,
      isLoading,
      loadingSucceeded,
      compoundedOptions: applicationFieldOptions.mortgageCompoundingPeriodOptions,
      amortizationScenarioOptions,
      mortgageFrequencyOptions: applicationFieldOptions.mortgageFrequencyOptions,
      hasScenario,
      isTopExtraPaymentAmountEditable,
      canCalculateWithNewPaymentStructure,
      scenarioTotals,
      originalTotals,
      footerData,
      interestAdjustmentAmount,
      roundReg,
      formatMoneyValueLong,
      handleInterestOnlyChange,
      handlePaymentOverrideChange,
      handleAgentChange,
      handleScenarioRowAmountChange,
      handleScenarioRowPercentChange,
      calculate,
      calculateWithNewPaymentStructure,
      onScenarioSelect,
      clearSelectedScenario,
      clearAllScenarios,
      clearAllExtraPayments,
      clearForm,
      runReport
    };
  }
});